import React, { useContext, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormContext } from '../FormContext';
import '../styles/paragraph.scss';

const icons = {
  warning: <i className="zmdi zmdi-alert-triangle" />,
};

const FormParagraph = props => {
  const { controlId, field, style } = props;

  const firstUpdate = useRef(true);

  const [value, setValue] = useState(props.value);
  const { ee } = useContext(FormContext);

  const consume = ({ action, payload: data }) => {
    if (action !== 'update') {
      return;
    }

    if (data.value !== undefined) {
      setValue(data.value);
    }
  };

  const print = () => {
    const win = window.open('', 'PRINT', 'height=400,width=600');

    win.document.write(`<pre>${value}</pre>`);
    win.document.close();
    win.focus();
    win.print();
    win.close();

    return true;
  };

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    props.onBlur(field.name);
  }, [value]);

  useEffect(() => {
    ee.on(controlId, consume);

    return () => ee.off(controlId);
  });

  const renderIcon = () => {
    if (!icons[style]) {
      return null;
    }

    return <div className="paragraph-icon">{icons[style]}</div>;
  };

  let text = Array.isArray(value) ? value.join('\n') : value;

  const className = classNames('form-paragraph', {
    [style]: !!style,
    'is-empty': !text,
  });

  if (!text) {
    text = 'Empty';
  }

  return (
    <div className={className}>
      {renderIcon()}
      <div className="paragraph-text">
        {style === 'classic' && (
          <div className="print-icon" onClick={print} role="presentation">
            <i className="zmdi zmdi-print" />
          </div>
        )}
        {text.split
          ? text.split('\n').map((item, key) => {
              return (
                <span key={key}>
                  {item}
                  <br />
                </span>
              );
            })
          : text}
      </div>
    </div>
  );
};

FormParagraph.defaultProps = {
  controlId: '',
  field: {},
  onBlur: () => {},
  style: 'plain',
  value: '',
};

FormParagraph.propTypes = {
  controlId: PropTypes.string,
  onBlur: PropTypes.func,
  field: PropTypes.object,
  style: PropTypes.string,
  value: PropTypes.string,
};

export default FormParagraph;
